import { DriverConcernsComponent } from './components/ManageDriver/driver-concerns/driver-concerns.component';
import { AssignedDriverComponent } from './components/ManageDriver/assigned-driver/assigned-driver.component';
import { DriverFeedbackComponent } from './components/ManageDriver/driver-feedback/driver-feedback.component';
import { DriverMasterComponent } from './components/ManageDriver/driver-master/driver-master.component';
import { NgModule } from "@angular/core";
import { Routes,RouterModule } from '@angular/router';

import { environment } from "../environments/environment";
import { HeaderComponent } from "./layout/header/header.component";
import { FooterComponent } from "./layout/footer/footer.component";
import { HomeComponent } from "./layout/home/home.component";
import { DashboardComponent } from "./components/dashboard/dashboard/dashboard.component";
import { RightinfoComponent } from "./layout/rightinfo/rightinfo/rightinfo.component";
import { TripdirectionComponent } from "./components/tripdirection/tripdirection.component";
import { RemainingscreenComponent } from "./components/remainingscreen/remainingscreen.component";
import { FinishedscreenComponent } from "./components/finishedscreen/finishedscreen.component";
import { TriprequestscreenComponent } from "./components/triprequestscreen/triprequestscreen.component";
import { AlertlogscreenComponent } from "./components/alertlogscreen/alertlogscreen.component";
import { DriverlistviewComponent } from "./components/driverlistview/driverlistview.component";
import { UploadscreenComponent } from "./components/uploadscreen/uploadscreen.component";
//import { UserTripsComponent } from './components/Master/user-trips/user-trips.component';
//import { TripMasterComponent } from '../app/components/Master/trip-master/trip-master.component';
import { TripMstComponent } from "./components/Master/trip-mst/trip-mst.component";
import { ScUserTripComponent } from "./components/Master/sc-user-trip/sc-user-trip.component";
import { RncUsersComponent } from "./components/Master/rnc-users/rnc-users.component";
/* 18-10-2019 */
import { CarMasterComponent } from "./components/ManageCar/car-master/car-master.component";
import { AssignedCarComponent } from "./components/ManageCar/assigned-car/assigned-car.component";
import { CarMainRequestComponent } from "./components/ManageCar/car-main-request/car-main-request.component";

import { CarRequestComponent } from "./components/car-request/car-request.component";
import { HouseMasterComponent } from "./components/ManageHouse/house-master/house-master.component";
import { AssignedHomeComponent } from "./components/ManageHouse/assigned-home/assigned-home.component";
import { HomeRequestComponent } from "./components/ManageHouse/home-request/home-request.component";
import { HouseRelocationComponent } from "./components/ManageHouse/house-relocation/house-relocation.component";
import { VendorDetailComponent } from "./components/ManageVendor/vendor-detail/vendor-detail.component";
import { AssignUserComponent } from "./components/ManageResource/assign-user/assign-user.component";

/* 18-10-2019 */
//import { UserComponent } from './components/Master/user/user.component';
import { LoginComponent } from "./components/login/login.component";
import { ExceldownloadComponent } from "./exceldownload/exceldownload.component";
import { DrivertripdetailsComponent } from "./components/drivertripdetails/attendance/drivertripdetails.component";
import { VehicleComponent } from "./components/drivertripdetails/vehicle/vehicle.component";
import { AuthGuard } from "./guard/auth.guard";

import { WelnessComponent } from "./components/welness/welness.component";
import { DriverConfigComponent } from './components/ManageDriver/driver-config/driver-config.component';
import { HouseUploadComponent } from './components/ManageHouse/house-upload/house-upload.component';
import { CarUploadComponent } from './components/ManageCar/car-upload/car-upload.component';
import { VdmsTabsComponent } from './components/vdms/vdms-tabs/vdms-tabs.component';
import { AddVehicleComponent } from './components/vdms/add-vehicle/add-vehicle.component';
import { FuelCardDetailsComponent } from './components/vdms/fuel-card-details/fuel-card-details.component';
import { AddFuelCardDetailsComponent } from './components/vdms/fuel-card-details/add-fuel-card-details/add-fuel-card-details.component';
import { FuelCardCreditComponent } from './components/vdms/fuel-card-credit/fuel-card-credit.component';
import { AddFuelCardCreditComponent } from './components/vdms/fuel-card-credit/add-fuel-card-credit/add-fuel-card-credit.component';


const appRoutes: Routes = [
  { path: "", component: LoginComponent },
  {
    path: '',
    redirectTo: 'pages',
    pathMatch: 'full',
  },
  {
    path: "pages",
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "excel",
        component: ExceldownloadComponent,
        canActivate: [AuthGuard]
      },
      { path: "wellness", component: WelnessComponent, canActivate: [AuthGuard] },
      // { path: 'dashboard/:trip_id', component: DashboardComponent},
      // { path: 'dash/:trip_id', component: DashboardComponent},
      {
        path: "dash/:trip_id",
        component: DriverlistviewComponent,
        canActivate: [AuthGuard]
      },
      // { path: 'tripdirection', component: TripdirectionComponent },
      {
        path: "finishedScreen",
        component: FinishedscreenComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "remainingScreen",
        component: RemainingscreenComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "triprequestScreen",
        component: TriprequestscreenComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "alertlogScreen",
        component: AlertlogscreenComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "uploadScreen",
        component: UploadscreenComponent,
        canActivate: [AuthGuard]
      },
      // { path: 'userTrips', component: UserTripsComponent, canActivate: [AuthGuard]},
      // { path: 'tripMaster',component: TripMasterComponent, canActivate: [AuthGuard]},
      { path: "tripmst", component: TripMstComponent, canActivate: [AuthGuard] },
      {
        path: "scusertrip",
        component: ScUserTripComponent,
        canActivate: [AuthGuard]
      },
      { path: "rncusers", component: RncUsersComponent, canActivate: [AuthGuard] },
    
      /* cap 18-10-2019 */
      {
        path: "rncardata",
        component: CarMasterComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "assign_car",
        component: AssignedCarComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "car_requestdata",
        component: CarRequestComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "car_maintenance",
        component: CarMainRequestComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "house_master",
        component: HouseMasterComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "assign_house",
        component: AssignedHomeComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "house_req",
        component: HomeRequestComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "driver_master",
        component: DriverMasterComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "assign_driver",
        component: AssignedDriverComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "driver_feedback",
        component: DriverFeedbackComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "driver_concerns",
        component: DriverConcernsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "house_relocation",
        component: HouseRelocationComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "vendor_detail",
        component: VendorDetailComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "assign_user",
        component: AssignUserComponent,
        canActivate: [AuthGuard]
      },
      /* cap 18-10-2019 */
    
      //{ path: 'user',component: UserComponent, canActivate: [AuthGuard]},
      // { path: 'user:id',component: UserComponent, canActivate: [AuthGuard]},
      {
        path: "drivertripdt",
        component: DrivertripdetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "driverconfig",
        component: DriverConfigComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "house_upload",
        component: HouseUploadComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "car_upload",
        component: CarUploadComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "vehiclems",
        component: VehicleComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "vdms",
        component: VdmsTabsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "addVehicle",
        component: AddVehicleComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "fuel-card-details",
        canActivate: [AuthGuard],
        component: FuelCardDetailsComponent
      },
      {
        path: "add-fuel-card-details",
        canActivate: [AuthGuard],
        component: AddFuelCardDetailsComponent
      },
      {
        path: "fuel-card-credit",
        canActivate: [AuthGuard],
        component: FuelCardCreditComponent
      },
      {
        path: "fuel-card-credit/:type",
        canActivate: [AuthGuard],
        component: AddFuelCardCreditComponent
      },
    ]
  },
 
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      onSameUrlNavigation: 'reload',
      useHash: true,
    })
  ],
  exports: [RouterModule]
})

// @NgModule({
//   imports: [
//     RouterModule.forRoot(appRoutes, {
//       onSameUrlNavigation: 'reload',
//       useHash: true
//     })
//     // RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload' }, { useHash: true })
//     //RouterModule.forRoot(appRoutes)
//   ],
//   exports: [RouterModule]
// })
export class AppRoutingModule { }
